module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAATlBMVEUAAABwdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5wdp5e4XPKAAAAGnRSTlMAzCLqWSnQ5mgS/Leyl3x2ZjcZ9N2nek0GYkjfp1cAAACESURBVAjXVY9bDsQgCEUvxbe11T6mnf1vdEC+5iRKPCR4geJWLrw6GAuF5LNPRMt88g5jYxX0AY77ug8RBLigro2mNTjUJO3zBc4M9Ar24uU8UWtEyVAGP3LnApmpXAnWr18Ib5s2VZsPjHmTs/+xTLvRX76dLTBRl/w9zPy2XyzR9vsB6cQD3Kb2YmgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/paySystem/icon_problem.png
// module id = j12n
// module chunks = 1